<template>
  <div v-if="params.row && params.row.load_status" class="chip-success"
    :style="{ 'background': chipBackgroundColor(params.row.load_status), 'border-color': chipBorder(params.row.load_status) }">
    <div :style="'background:' + chipColor(params.row.load_status)" class="chip-success__circle"></div>
    <span :style="'color:' + chipColor(params.row.load_status)">{{ chipText(params.row.load_status) }}
      <el-tooltip v-if="params.row && params.row.customer_portal_pickup_comments ||
        params.row.customer_portal_delivery_comments" popper-class="custom-tooltip" effect="light"
        placement="right-start">
        <div slot="content">
          <b>Pickup</b><br />{{ params.row.customer_portal_pickup_comments }}
          <br /><b>Delivery</b><br />{{ params.row.customer_portal_delivery_comments }}
        </div>
        <svg :style="'fill:' + chipColor(params.row.load_status)" class="chip-success__icon"
          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
          <path
            d="M64 304C64 358.4 83.3 408.6 115.9 448.9L67.1 538.3C65.1 542 64 546.2 64 550.5C64 564.6 75.4 576 89.5 576C93.5 576 97.3 575.4 101 573.9L217.4 524C248.8 536.9 283.5 544 320 544C461.4 544 576 436.5 576 304C576 171.5 461.4 64 320 64C178.6 64 64 171.5 64 304zM158 471.9C167.3 454.8 165.4 433.8 153.2 418.7C127.1 386.4 112 346.8 112 304C112 200.8 202.2 112 320 112C437.8 112 528 200.8 528 304C528 407.2 437.8 496 320 496C289.8 496 261.3 490.1 235.7 479.6C223.8 474.7 210.4 474.8 198.6 479.9L140 504.9L158 471.9zM208 336C225.7 336 240 321.7 240 304C240 286.3 225.7 272 208 272C190.3 272 176 286.3 176 304C176 321.7 190.3 336 208 336zM352 304C352 286.3 337.7 272 320 272C302.3 272 288 286.3 288 304C288 321.7 302.3 336 320 336C337.7 336 352 321.7 352 304zM432 336C449.7 336 464 321.7 464 304C464 286.3 449.7 272 432 272C414.3 272 400 286.3 400 304C400 321.7 414.3 336 432 336z" />
        </svg>
      </el-tooltip>
    </span>
    <!--<CommentsDots :styleStatus="chipColor(params?.row.load_status)" />-->
  </div>
</template>
<script>
import LoadStatusType from "../../Extend/LoadStatusType";
// import CommentsDots from "../icons/CommentsDots.vue";

export default {
  name: "StatusLoad",
  props: {
    params: {
      type: Object,
    },
  },
  mixins: [LoadStatusType],
  /* components: {
    CommentsDots,
  }, */
  methods: {
    chipColor(value) {
      let color = "default";
      color = this.setLoadStatusColor(value).color;
      return color;
    },
    chipText(value) {
      let label = "default";
      label = this.setLoadStatusColor(value).label;
      return label;
    },
    chipBackgroundColor(value) {
      let backgroundColor = "#000000";
      backgroundColor = this.setLoadStatusColor(value).backgroundColor;
      return backgroundColor;
    },
    chipBorder(value) {
      let border = "#000000";
      border = this.setLoadStatusColor(value).border;
      return border;
    },
  },
};
</script>

<style scoped lang="scss">
.chip-success {
  padding: 5px 10px;
  border-radius: 15px;
  border: 1px solid;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;

  &__circle {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    border: none;
  }

  &__icon {
    width: 20px;
    padding-left: 5px;
  }
}

.tooltip-container {
  display: flex;
  flex-direction: column;
  visibility: visible;
  opacity: 1;
  transform: scale(1);
  width: 200px;
  background-color: #fff;
  color: #333;
  text-align: center;
  border-radius: 8px;
  padding: 12px;
  position: absolute;
  z-index: 2;
  top: 7px;
  left: 220px;
  margin-left: -100px;
  transition: opacity 0.3s ease, transform 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  z-index: 999;

  &__text-pickup,
  &__text-delivery {
    text-align: left;
  }

  &__text-pickup {
    margin-bottom: 6px;
  }
}

.tooltip-container::after {
  content: "";
  position: absolute;
  right: 98%;
  top: 8px;
  width: 0.5rem;
  height: 0.5rem;
  transform: rotate(45deg);
  background: #fff;
}
</style>
